export const MOBILE_VIEW_COOKIE = 'mobileViewCookie';
export const MOBILE_VIEW_QUERY = 'webview';
export const BASKET_URL = '/basket';
export const LOGO_URL = '/shop/catalog/telefony/smartfony/';
